import React, { useState, useEffect } from 'react';
import Redirect from 'react-dom';

import './index.css';
import AuthService from '../../components/AuthService';
import { createBrowserHistory } from 'history';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../components/Auth';

const history = createBrowserHistory();

export default function LogoutAll(props) {
	const auth = useAuth();
  useEffect(() => {
    auth.fetch(`/api/logoutall`).then(res => {
        var nurl = new URL(window.location.href);
        var refUrl = nurl.searchParams.get("service");
        if (refUrl) {
          window.location.href = auth.schemhttp+"://"+auth.getDomainWithoutSubdomain(window.location.href)+"/login?service="+refUrl;
          return
        } else {
          window.location.href = "/app/login";
          return
        }
    })
	}, []);

	return (
		<>
		</>
	);
}